import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import './Captcha.scss';

const Captcha = (props) => {
    return(
        <ReCAPTCHA
            className="captcha"
            sitekey={props.sitekey}
            onChange={props.onChange} />
    );
};

Captcha.propTypes = {
    onChange: PropTypes.func,
    sitekey: PropTypes.string
};

export default Captcha;



// WEBPACK FOOTER //
// ./src/components/Captcha/Captcha.js